import * as immer from "immer";

immer.enableMapSet();

/** Wrapper module around `jotai-immer` that enables {@link Map} and {@link Set} functionality */
export * from "jotai-immer";
